import React, { useState } from 'react';
import { Star, ChevronDown, ChevronUp } from 'lucide-react';
interface Review {
  id: number;
  name: string;
  rating: number;
  date: string;
  text: string;
  truncated?: boolean;
}
const reviews: Review[] = [{
  id: 1,
  name: 'Gustavo Guerra',
  rating: 1,
  date: 'Oct 14, 2025',
  text: 'Lo bueno:Hace varios meses me inscribí al curso de Meta Ads y fue realmente excelente. Mis resultados se dispararon y siempre estaré agradecido por...',
  truncated: true
}, {
  id: 2,
  name: 'Gabriel',
  rating: 5,
  date: 'Jun 07, 2025',
  text: 'Curso de 0 a 100 de Meta Ads, donde vemos no solo la parte inicial e introductoria de Meta Ads sino también la parte más avanzada a nivel técnico, per...',
  truncated: true
}, {
  id: 3,
  name: 'Axel Duarte',
  rating: 5,
  date: 'Jan 15, 2025',
  text: 'Adquirí el curso hace casi 2 meses, y la verdad que super contento con todo el aprendizaje que me esta dejando. No solo por parte de las clases sino ...',
  truncated: true
}, {
  id: 4,
  name: 'Natalia Appugliese',
  rating: 5,
  date: 'Apr 13, 2024',
  text: 'Curso práctico, fácil de comprender, muy bien explicado.'
}, {
  id: 5,
  name: 'Natali Gerstein',
  rating: 5,
  date: 'Jun 09, 2025',
  text: 'Formarme en Área 8 fue mucho más que aprender sobre pauta publicitaria. Si bien llegué buscando mejorar mis habilidades técnicas como paid media strat...',
  truncated: true
}, {
  id: 6,
  name: 'Guido Garofalo',
  rating: 5,
  date: 'Jun 07, 2025',
  text: 'La formación en Meta Ads de Área 8 es de lo más completo del mercado. Con ejemplos, plantillas y sobre todo detrás de escena de sus propios clientes y...',
  truncated: true
}, {
  id: 7,
  name: 'María Alejandra Rodríguez',
  rating: 5,
  date: 'Nov 07, 2024',
  text: 'Me encanto el curso'
}, {
  id: 8,
  name: 'Laura Comesaña',
  rating: 5,
  date: 'Apr 09, 2024',
  text: 'Excelentes curso!!!! Muy bien explicados por lo cual son llevaderos y entendibles. Super recomendable!!!!'
}, {
  id: 9,
  name: 'Director de Agencia',
  rating: 5,
  date: 'Mar 22, 2024',
  text: 'Como director de agencia y especialista con mas de 20 años en marketing, hice cientos de cursos...'
}, {
  id: 10,
  name: 'Estudiante Verificado',
  rating: 5,
  date: 'Jun 08, 2025',
  text: 'Un curso muy bien explicado y dinámico!'
}, {
  id: 11,
  name: 'Profesional Marketing',
  rating: 5,
  date: 'Jun 04, 2025',
  text: 'Curso de 0 a 100 de Meta Ads, donde vemos no solo la parte inicial e introductoria de Meta Ads sino también la parte más avanzada...'
}, {
  id: 12,
  name: 'Emprendedor Digital',
  rating: 5,
  date: 'May 29, 2024',
  text: 'Un curso muy bien explicado y dinámico!'
}];
function StarRating({
  rating
}: {
  rating: number;
}) {
  return <div className="flex gap-0.5" data-id="element-490">
      {[1, 2, 3, 4, 5].map(star => <Star key={star} className={`w-5 h-5 ${star <= rating ? 'fill-yellow-400 text-yellow-400' : 'fill-gray-200 text-gray-200'}`} data-id="element-491" />)}
    </div>;
}
function GoogleIcon() {
  return <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" data-id="element-492">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#0866FF" data-id="element-493" />
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#0866FF" data-id="element-494" />
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#0866FF" data-id="element-495" />
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#0866FF" data-id="element-496" />
    </svg>;
}
export function ReviewsSection() {
  const [isExpanded, setIsExpanded] = useState(false);
  const visibleReviews = isExpanded ? reviews : reviews.slice(0, 3);
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-497">
      <div className="max-w-7xl mx-auto px-6" data-id="element-498">
        {/* Header */}
        <div className="flex items-start justify-between mb-12" data-id="element-499">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-500">
            Que dicen nuestros alumnos
          </h2>
          <div className="text-right" data-id="element-501">
            <div className="text-5xl font-bold text-gray-900 mb-1" data-id="element-502">4.90</div>
            <div className="flex items-center gap-2 mb-1" data-id="element-503">
              <StarRating rating={5} data-id="element-504" />
            </div>
            <div className="text-sm text-gray-500" data-id="element-505">104 reviews</div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-506">
          {visibleReviews.map(review => <div key={review.id} className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow" data-id="element-507">
              {/* Rating and Date */}
              <div className="flex items-center justify-between mb-4" data-id="element-508">
                <div className="flex items-center gap-2" data-id="element-509">
                  <span className="text-2xl font-bold text-yellow-500" data-id="element-510">
                    {review.rating}
                  </span>
                  <StarRating rating={review.rating} data-id="element-511" />
                </div>
                <span className="text-sm text-gray-500" data-id="element-512">{review.date}</span>
              </div>

              {/* Review Text */}
              <p className="text-gray-700 text-sm leading-relaxed mb-4" data-id="element-513">
                {review.text}
                {review.truncated && <button className="text-blue-600 hover:underline ml-1 font-medium" data-id="element-514">
                    More
                  </button>}
              </p>

              {/* Reviewer Info */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-100" data-id="element-515">
                <span className="text-sm font-medium text-gray-900" data-id="element-516">
                  {review.name}
                </span>
                <GoogleIcon data-id="element-517" />
              </div>
            </div>)}
        </div>

        {/* Expand/Collapse Button */}
        <div className="text-center" data-id="element-518">
          <button onClick={() => setIsExpanded(!isExpanded)} className="inline-flex items-center gap-2 px-6 py-3 bg-[#0866FF] text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors" data-id="element-519">
            {isExpanded ? <>
                Ver menos reviews
                <ChevronUp className="w-5 h-5" data-id="element-520" />
              </> : <>
                Ver más reviews ({reviews.length - 3} más)
                <ChevronDown className="w-5 h-5" data-id="element-521" />
              </>}
          </button>
        </div>
      </div>
    </section>;
}